import {
  Dialog,
  Grid,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import TransferReasonService from "./TransferReasonService";
import { useContext } from "react";
import { ContextOperation } from "../../context/OperationContext";
import useSnackbar from "../../hooks/useSnackbar";

interface Props {
  setOpenDeleteModal: (value: boolean) => void;
  openDeleteModal: boolean;
  modalData: any;
  updateDatasourceAcriss: () => void;
}

const DeleteModal = (props: Props) => {
  const t = useOperationTranslation();
  const snackbar = useSnackbar();
  const { setLoading } = useContext(ContextOperation);

  const onClickCloseDialog = () => {
    props.setOpenDeleteModal(false);
  };

  const handleSubmit = () => {
    setLoading(true);
    onClickCloseDialog();
    TransferReasonService.put
      .deleteTransferReason(props.modalData.id)
      .then(() => {
        props.updateDatasourceAcriss();
        setLoading(false);
        snackbar.show("success", t("transferReason.messages.successDelete"));
      })
      .catch(() => {
        setLoading(false);
        snackbar.show("error", t("transferReason.messages.errorDelete"));
      });
  };

  return (
    <Dialog
      open={props.openDeleteModal}
      PaperProps={{
        sx: {
          minWidth: "600px !important",
          height: "248px",
          borderRadius: "4px",
        },
      }}
    >
      <DialogTitle>
        <Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Grid
            sx={{
              color: "#C8017D",
            }}
          >
            <InfoIcon />
          </Grid>
          <Grid xs item>
            {t("transferReason.delete.title")}
          </Grid>
          <Grid
            xs
            item
            sx={{
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <CloseIcon
              color="disabled"
              fontSize="small"
              onClick={onClickCloseDialog}
            />
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <DialogContentText whiteSpace="pre-line">
          {t("transferReason.delete.body")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} p={1} mr={1}>
          <Button
            sx={{
              maxWidth: "600px",
              maxHeight: "80px",
              minWidth: "111px",
              minHeight: "48px",
            }}
            variant="outlined"
            onClick={onClickCloseDialog}
          >
            <Typography
              sx={{
                textTransform: "capitalize",
                fontWeight: 700,
                lineHeight: 2.25,
                color: "#C8017D",
              }}
              variant="subtitle1"
            >
              {t("actionButtons.cancel")}
            </Typography>
          </Button>

          <Button
            sx={{
              maxWidth: "111px",
              maxHeight: "48px",
              minWidth: "111px",
              minHeight: "48px",
            }}
            variant="contained"
            color="accent"
            onClick={handleSubmit}
          >
            <Typography
              sx={{
                textTransform: "capitalize",
                fontWeight: 700,
                lineHeight: 2.25,
                color: "white",
              }}
              variant="subtitle1"
            >
              {t("actionButtons.confirm")}
            </Typography>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
